import CustomAxios from "..";
export const uploadMeditationData = async (formData, fileName) => {
  try {
    const response = await CustomAxios.post(
      `/meditation/json?fileName=${encodeURIComponent(fileName)}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
};

export const updateStatusMeditation = async (id) => {
  try {
    const response = await CustomAxios.patch(
      `/meditation/update-status/${id}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
}; 

export const deleteMeditationDataById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/meditation/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};


export const getMeditationDataById = async (id) => {

  try {
    const response = await CustomAxios.get(`/meditation/${id}`);
    
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

export const getAllMeditationData = async () => {
  try {
    const response = await CustomAxios.get("/meditation");
    return response.data;
  } catch (error) {
    throw error;
  }
};
